import * as classNames from 'classnames';
import { Data } from '../process/DataConfig';
import { DataService } from '../../../services/data_service';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import style from '../import_tool.less';

interface ImportMappingValuesProps extends React.ClassAttributes<any> {
    modul: string;
    structure: any;
    fieldData: Array<string>;
    selectedFields: any;
    selectedValues: any;
    usedValues: Array<string>;
    onChange(field: string, target: string): void;
    onValueChange(target: string, value: string): void;
}

interface ImportMappingValuesState {
    bundle: any;
}

export class ImportMappingValues extends React.Component<ImportMappingValuesProps, ImportMappingValuesState> {

    constructor(props: any) {
        super(props);
        this.state = {
            bundle: null
        };
    }

    @lazyInject(DataService) private dataService: DataService;

    private atts: Array<any> = [];
    private entity: string = null;
    private fields: any = {};

    componentDidMount(): void {
        const structure: any = this.props.structure || {};
        this.atts = structure.ATTS || [];
        this.entity = (structure.SRC || {}).id || null;
        this.fields = { ...Data.selector[this.entity] || {} };
        this.loadBundle(this.entity);
    }

    loadBundle(entity: string): void {
        this.dataService.loadDataForModul(
            entity, { tid: null }, { bundle: true }, this.props.modul,
            (data: any) => {
                const bundle: any = this.processBundle((data || {}).bundle) || {};
                this.setState({ bundle })
            }
        );
    }

    processBundle(data: any): any {
        Object.keys(data || {}).forEach((key: string) => {
            const name: string = this.atts.find((att: any) => att.KEY === key).NAME || null;
            const selectedValues: any = this.props.selectedValues || {};
            const valueKeys: Array<string> = Object.keys(selectedValues);

            if (valueKeys.indexOf(key) !== -1) {
                const value: string = selectedValues[key];

                if ((this.props.fieldData || []).indexOf(name) === -1) {
                    this.props.onChange(name, key);
                    this.props.onValueChange(key, value);
                } else {
                    this.props.onValueChange(key, undefined);
                }
            }

            if ((this.props.fieldData || []).indexOf(name) !== -1) {
                delete this.fields[key];
                return;
            }
            const bundle: Array<any> = data[key] || [];
            const filter: any = (this.fields[key] || {}).filter || {};

            if (Object.keys(filter).length) {
                bundle.forEach((item: any, index: number) => {
                    Object.keys(filter).forEach((field: any) => {
                        if (typeof item[field] !== 'undefined' && (filter[field] !== item[field])) {
                            delete data[key][index];
                        }
                    });
                });
            }
        });

        return data;
    }

    render(): JSX.Element {
        const fields: Array<string> = Object.keys(this.fields) || [];

        if (!this.state.bundle || !fields.length) {
            return null;
        }

        return (
            <div style={{ marginBottom: 5, paddingTop: 5, paddingBottom: 5, borderBottom: '1px solid' }}>
                <div className={style.rowContainer}>
                    {fields.map((key: string, index: number) => this.state.bundle[key]
                        ? <React.Fragment key={`select-${index}`}>{this.renderSelect(key)}</React.Fragment>
                        : null
                    )}
                </div>
            </div>
        );
    }

    renderOption(data: any): JSX.Element {
        return (
            <option
                key={`option-${data.tid}`}
                value={data.name || 'UNUSED'}
            >
                {data.name || null}
            </option>
        );
    }

    renderSelect(key: string): JSX.Element {
        const disabled: boolean = (this.props.usedValues || []).indexOf(key) !== -1
            && typeof (this.props.selectedValues || {})[key] === 'undefined';
        const name: string = this.atts.find((att: any) => att.KEY === key).NAME || null;

        return (
            <>
                <div className={classNames(style.flexItem, style.w200)}>
                    {name}
                </div>
                <div className={style.flexItem}>
                    <select
                        className={style.w300}
                        onChange={(event: any) => {
                            this.props.onChange(name, event.target.value !== 'UNUSED' ? key : event.target.value);
                            this.props.onValueChange(key, event.target.value);
                        }}
                        value={this.props.selectedValues[key]}
                        disabled={disabled}
                    >
                        <option value='UNUSED'>
                            {'<keine Auswahl>'}
                        </option>
                        {(this.state.bundle[key] || []).map((item: any) => this.renderOption(item))}
                    </select>
                </div>
            </>
        );
    }
}
